import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-chip-filter-field',
  standalone: false,
  templateUrl: './chip-filter-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./chip-filter-field.component.scss']
})
export class ChipFilterFieldComponent {
  @Input() label: string = '';
  @Input() placeholder: string = 'Sök...';
  @Input() options: string[] = [];
  @Input() selected: string[] = [];
  @Input() disabled: boolean = false;

  @Output() inputChange = new EventEmitter<string>();
  @Output() optionSelected = new EventEmitter<string>();
  @Output() removed = new EventEmitter<string>();

  @ViewChild('inputEl') inputEl!: ElementRef<HTMLInputElement>;

  inputValue: string = '';

  onInput(event: Event): void {
    this.inputChange.emit((event.target as HTMLInputElement).value);
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    this.inputValue = '';
    if (this.inputEl) {
      this.inputEl.nativeElement.value = '';
    }
    this.optionSelected.emit(event.option.value);
  }

  onRemove(value: string): void {
    this.removed.emit(value);
  }
}
